module.exports = __webpack_public_path__ + "static/media/edeka4.c08dc687.jpg";